/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row align-start wrap fill-height>
    <v-flex xs12 md8 sm12>
      <Graph :fullDate="fullDate" :blockList="blockList" :totalGen="totalInvGen" />
    </v-flex>
    <v-flex xs12 md4 sm12 v-show="isLargeScreen">
      <SideCard @blockData="blockDataHandler" @activeBlock="(val) => blockId = val" :dateFrom="activeFilter['Date'].from" :dateTo="activeFilter['Date'].to" @totalGen="totalInvGenHandler" />
    </v-flex>
  </v-layout>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import {
  mixin,
  mapGettersMixin
} from '@/util/mixin/index'
const momentTz = require('moment-timezone')
const Graph = () => import('@/components/dashboard-inverter/Graph')
const SideCard = () => import('@/components/dashboard-inverter/SideCard')

// TODO: Map redirect have to be handled
export default {
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [ mixin, mapGettersMixin ],
  components: {
    Graph,
    SideCard
  },
  data() {
    return {
      filter: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
      ],
      activeFilter: {},
      blockList: [],
      windowWidth: window.innerWidth,
      blockId: null,
      totalInvGen: 0,
    }
  },
  computed: {
    ...mapGetters(['getActivePlantTimezone']),
    fullDate() {
      return this.activeFilter.Date ? [this.activeFilter.Date.from, this.activeFilter.Date.to] : ['', '']
    },
    isLargeScreen() {
      return this.windowWidth > 960;
    },
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'datePicker') {
        const parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.SET_MAP_REDIRECT_BLOCK(false)
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations(['SET_MAP_REDIRECT_BLOCK']),
    blockDataHandler(payload) {
      this.blockList = payload;
    },
    totalInvGenHandler(val) {
      this.totalInvGen = val;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
@media (max-width:960px ) {
  .hide {
    display: none;
  }
}
@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.main-background {
  background-color: #2a335a;
}

.theme--dark {
  width: -webkit-fill-available;
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .v-card {
    width: 200px !important;
  }
}

</style>